module.exports = __webpack_public_path__ + "img/y.78a81fca.png";